import { queryOptions } from '@tanstack/react-query';

import type { Tables } from '@archetelos/db';

import { supabase } from '@/lib/supabase';

export type Profile = Tables<'profiles'>;

export const profileQueries = {
  byId: (userId: string | undefined) =>
    queryOptions({
      queryKey: ['profile', userId] as const,
      queryFn: async (): Promise<Profile> => {
        if (!userId) throw new Error('profile query requires a user id');
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', userId)
          .single();
        if (error) throw error;
        return data as Profile;
      },
      enabled: Boolean(userId),
      staleTime: 1000 * 30,
    }),

  checkUsernameAvailable: (username: string) =>
    queryOptions({
      queryKey: ['username-available', username.toLowerCase()] as const,
      queryFn: async (): Promise<boolean> => {
        const { data, error } = await supabase.rpc('check_username_available', {
          check_username: username,
        });
        if (error) throw error;
        return Boolean(data);
      },
      enabled: username.trim().length >= 3,
      staleTime: 1000 * 5,
    }),
};
